import {
  CONFIG_API_BASE_URL,
  CURR_ENV,
  IS_DEBUG,
} from '@/core/constants/appConfig/environment';
import { EScriptEnv } from '@/core/constants/appConfig/types';
import { EMableEventName } from '@/core/constants/event_types/events';
import { ScriptHandler } from '@/core/handlers/script';
import { EDestinationType } from '@/core/interfaces';
import { callAPI } from '@/shared/fetch_client';
import { Logger } from '@/shared/logger/logger';

import {
  ECatalogItemIdentifierType,
  EShopSystem,
  ShopConfigData,
} from './config_api_types';

export const ConfigApi = {
  /**
   * Returns the basePath
   */
  get basePath(): string {
    const basePath = '/config/v1';
    return basePath;
  },

  /**
   * If no sourceUid is passed it tries to get sourceUid from Script Handler ( the script url's query params. )
   * @param sourceUid Optional parameter to get the config data for a specific source
   * @returns
   */
  async get(): Promise<ShopConfigData> {
    return Logger.profileFnAsync('ConfigApi:get', async () => {
      try {
        const response = await callAPI<ShopConfigData>({
          method: 'GET',
          params: {
            uid: ScriptHandler.getInstance().getSourceUid(),
          },
          url: `${CONFIG_API_BASE_URL}${ConfigApi.basePath}`,
        });

        if (!response.data?.active) {
          throw new Error('Failed to get config data');
        }
        return response.data;
      } catch (error) {
        if ([EScriptEnv.DEV, EScriptEnv.LOCAL].includes(CURR_ENV) && IS_DEBUG) {
          Logger.error('Failed to get config data', error);
          return {
            active: true,
            config: {},
            customEvents: [
              {
                baseEvent: EMableEventName.PAGE_VIEWED,
                eventName: 'PlaygroundPageView',
                triggerCondition: {
                  field: 'pd.dl',
                  operator: 'contains',
                  value: '/playground/',
                },
              },
            ],
            destinations: [
              {
                active: true,
                businessLogic: {},
                creds: {
                  catalog_item_identifier_type:
                    ECatalogItemIdentifierType.VARIANT_ID,
                  pixelId: '1471314667031484',
                },
                id: '4633089c-b234-458f-b920-38a934280797',
                type: EDestinationType.Facebook,
              },
              {
                active: true,
                businessLogic: {},
                creds: {
                  adwordsId: 'AW-475399036',
                  catalog_item_identifier_type:
                    ECatalogItemIdentifierType.VARIANT_ID,
                },
                id: '1ec915b2-8119-47fb-bded-bef121130221',
                type: EDestinationType.GoogleAds,
              },
            ],
            sourceType: EShopSystem.SHOPIFY,
            uid: 'gokullocalstore.myshopify.com',
          } satisfies ShopConfigData;
        } else {
          Logger.error('Failed to get config data', error);
          throw error;
        }
      }
    });
  },
};
